import i18n from '../../locales/index'
import restful from '../vuex';
import axios from 'axios'
import {
  Spin
} from 'view-design'
import {
  localRead,
  localSave
} from '@/libs/util';
import config from '@/config'

const state = {
  ...restful.states('permissions'),
};

const getters = {
  ...restful.getters('permissions'),
  generalAdminExcludePermissions: (state) => {
    const result = state.permissions.find((item) => item.name === 'generalAdminExclude');
    return result ? result.fresh_permission_items : [];
  },
  standardAdminExcludePermissions: (state) => {
    const result = state.permissions.find((item) => item.name === 'standardAdminExclude');
    return result ? result.fresh_permission_items : [];
  },
};

const actions = {
  ...restful.actions('permissions'),

  async localSavePermissions({
    commit,
    getters,
    dispatch
  }) {
    await dispatch('index', {
      page: 1,
      per: 999
    })

    const se = localRead('software_version_name');
    if (se === 'standard') {
      localSave('adminExcludePermissions', JSON.stringify(getters.standardAdminExcludePermissions));
    } else {
      localSave('adminExcludePermissions', JSON.stringify(getters.generalAdminExcludePermissions));
    }
  }
};

const mutations = {
  ...restful.mutations('permissions'),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
